/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { ReactElement, useState, useEffect } from "react"
import { useFormik } from "formik"
import { Button, Box, Grid } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { BaseCFCStruct } from "../../../data/_config/shape"
import { initialValues } from "."
import { PanelsTitle } from "../../CFC"
import Spacer from "../../Spacer/Spacer"
import { routeVarReplacement, PrivateRoutes } from "../../../util/routes/routes"
import useCurrentClient from "../../../state/client/useCurrentClient"
import useStyles from "./__config/styles"
import formatNumber from "../../../util/formatNumber"
import onCreate from "./onCreate"
import CFCUseCase from "../../../data/CFC/CFCLogic"
import { useParams } from "react-router-dom"
import formatNumberZero from "../../../util/formatNumberZore"

const initPodaci = {
	"AKTIVNOSTI MIMO GRADNJE": [
		{
			Naziv: "Kupovina parcele",
			NDT: "pausal",
			MP: "",
			ki: "",
			"MP*ki": "",
			c: "",
			C: 760000.0,
			Trajanje: "",
			Iznos: 0,
			Interval: 5,
		},
		{
			Naziv: "Upravljanje projektom",
			NDT: "pausal",
			MP: "",
			ki: "",
			"MP*ki": "",
			c: "",
			C: 17600.0,
			Trajanje: "",
			Iznos: 0,
			Interval: 2,
		},
		{
			Naziv: "Projektovanje",
			NDT: "bruto",
			MP: 2200,
			ki: "",
			"MP*ki": "",
			c: 25,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 7,
		},
		{
			Naziv: "Gradsko građevinsko zemljište, takse",
			NDT: "pausal",
			MP: "",
			ki: "",
			"MP*ki": "",
			c: "",
			C: 131034.48,
			Trajanje: "",
			Iznos: 0,
			Interval: 2,
		},
		{
			Naziv: "Ostali radovi - rezerva",
			NDT: "pausal",
			MP: "",
			ki: "",
			"MP*ki": "",
			c: "",
			C: 100000.0,
			Trajanje: "",
			Iznos: 0,
			Interval: null,
		},
	],
	'AKTIVNOSTI KOJE SE "NE VIDE"': [
		{
			Naziv: "Šipovi",
			NDT: "kom",
			MP: 58,
			ki: "",
			"MP*ki": "",
			c: 800,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 7,
		},
		{
			Naziv: "Zaštita temeljne jame sa iskopom i HI",
			NDT: "obim",
			MP: 696,
			ki: "",
			"MP*ki": "",
			c: 75,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 15,
		},
		{
			Naziv: "AB radovi - podzemno",
			NDT: "bruto",
			MP: 680,
			ki: "",
			"MP*ki": "",
			c: 180,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 2,
		},
		{
			Naziv: "AB radovi - nadzemno",
			NDT: "bruto",
			MP: 1520,
			ki: "",
			"MP*ki": "",
			c: 150,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 2,
		},
		{
			Naziv: "Zidarski radovi - spoljni zidovi",
			NDT: "bruto",
			MP: 1520,
			ki: 0.859,
			"MP*ki": "",
			c: 30,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 1,
		},
		{
			Naziv: "Zidarski radovi - unutrašnji zidovi",
			NDT: "bruto",
			MP: 1520,
			ki: 0.704,
			"MP*ki": "",
			c: 25,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 1,
		},
		{
			Naziv: "Zidarski radovi - malterisanje",
			NDT: "bruto",
			MP: 1520,
			ki: 2.946,
			"MP*ki": "",
			c: 9,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 1,
		},
		{
			Naziv: "Zidarski radovi - košuljica",
			NDT: "bruto",
			MP: 1520,
			ki: 0.763,
			"MP*ki": "",
			c: 8,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 1,
		},
		{
			Naziv: "Krov sa termikom i olucima",
			NDT: "sprat",
			MP: 178,
			ki: 1.08,
			"MP*ki": "",
			c: 75,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 5,
		},
		{
			Naziv: "Ostali radovi - rezerva",
			NDT: "pausal",
			MP: "",
			ki: "",
			"MP*ki": "",
			c: "",
			C: 50000,
			Trajanje: "",
			Iznos: 0,
			Interval: null,
		},
	],
	"AKTIVNOSTI KOJE DEFINIŠU KVALITET": [
		{
			Naziv: "Završni radovi - podzemno",
			NDT: "bruto",
			MP: 680,
			ki: "",
			"MP*ki": "",
			c: 80,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 3,
		},
		{
			Naziv: "VIK - instalacije",
			NDT: "bruto",
			MP: 1520,
			ki: "",
			"MP*ki": "",
			c: 30,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 5,
		},
		{
			Naziv: "Elektro - instalacije",
			NDT: "bruto",
			MP: 1520,
			ki: "",
			"MP*ki": "",
			c: 60,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 10,
		},
		{
			Naziv: "Mašinske - instalacije",
			NDT: "bruto",
			MP: 1520,
			ki: "",
			"MP*ki": "",
			c: 45,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 8,
		},
		{
			Naziv: "Mašinske - liftovi",
			NDT: "f",
			MP: 1,
			ki: "",
			"MP*ki": "",
			c: 45000,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 5,
		},
		{
			Naziv: "Keramičarski radovi sa HI",
			NDT: "bruto",
			MP: 1520,
			ki: 0.551,
			"MP*ki": "",
			c: 45,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 7,
		},
		{
			Naziv: "Molersko farbarski radovi",
			NDT: "bruto",
			MP: 1520,
			ki: 2.624,
			"MP*ki": "",
			c: 8,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 1,
		},
		{
			Naziv: "Stolarski radovi - vrata",
			NDT: "bruto",
			MP: 1520,
			ki: 0.057,
			"MP*ki": "",
			c: 180,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 3,
		},
		{
			Naziv: "Parketarski radovi",
			NDT: "bruto",
			MP: 1520,
			ki: 0.535,
			"MP*ki": "",
			c: 60,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 2,
		},
		{
			Naziv: "Bravarski radovi - stolarija",
			NDT: "bruto",
			MP: 1520,
			ki: 0.131,
			"MP*ki": "",
			c: 210,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 5,
		},
		{
			Naziv: "Bravarski radovi - ograde",
			NDT: "bruto",
			MP: 1520,
			ki: 0.055,
			"MP*ki": "",
			c: 90,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 7,
		},
		{
			Naziv: "Suva gradnja",
			NDT: "bruto",
			MP: 1520,
			ki: 0.236,
			"MP*ki": "",
			c: 23,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 10,
		},
		{
			Naziv: "Fasaderski radovi",
			NDT: "obim",
			MP: 1548,
			ki: 1.102,
			"MP*ki": "",
			c: 35,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 5,
		},
		{
			Naziv: "Spoljno uređenje",
			NDT: "A(1-kz)",
			MP: 120,
			ki: "",
			"MP*ki": "",
			c: 50,
			C: "",
			Trajanje: "",
			Iznos: 0,
			Interval: 15,
		},
		{
			Naziv: "Ostali radovi - rezerva",
			NDT: "pausal",
			MP: "",
			ki: "",
			"MP*ki": "",
			c: "",
			C: 75000,
			Trajanje: "",
			Iznos: 0,
			Interval: null,
		},
	],
}

/**
 * Create canvas form.
 *
 * @export
 * @returns {ReactElement}
 */
export default function Step3Form({
	osveziMaster,
	values,
}: {
	osveziMaster: (values: any) => void
	values: any
}): ReactElement {
	const styles = useStyles()
	const { id: canvasId } = useParams<any>()

	const [useCustomTitle, setUseCustomTitle] = useState(false)
	const history = useHistory()
	const [currentClient] = useCurrentClient()

	const {
		setFieldValue,
		handleChange,
		// values,
		handleSubmit,
	} = useFormik<BaseCFCStruct>({
		initialValues,
		onSubmit: async (formValues: BaseCFCStruct) => {},
	})

	const { step1Items, step1CalculatedData, step2Items, step3Items } = values

	const podzemnoSpratnost = step2Items ? step2Items.spratType : undefined
	const nadzemnoSpratnost =
		step1CalculatedData && step1CalculatedData[10]
			? step1CalculatedData[10][1]
			: undefined //6

	const onPrev = async () => {
		if (currentClient?.id) {
			values.step3Items = rows
			values.ukupniTroskovi = Object.values(rows)
				.flat()
				.reduce((total, item: any) => total + item.Iznos, 0)

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line
			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep2, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}
	const onNext = async () => {
		if (currentClient?.id) {
			values.step3Items = rows
			values.ukupniTroskovi = Object.values(rows)
				.flat()
				.reduce((total, item: any) => total + item.Iznos, 0)

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line

			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep4, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}

	useEffect(() => {
		if (!useCustomTitle) {
			setFieldValue("canvasTitle", "")
		}
	}, [useCustomTitle, setFieldValue])

	const [rows, setRows] = useState<any[]>(step3Items ? step3Items : initPodaci)

	const pronadjiTrajanjeZaAktivnost = (podaci, nazivAktivnosti) => {
		// Prolazimo kroz sve ključeve u objektu podaci
		for (const kategorijaNaziv in podaci) {
			if (Object.hasOwnProperty.call(podaci, kategorijaNaziv)) {
				const kategorija = podaci[kategorijaNaziv]

				// Prolazimo kroz sve elemente u ovoj kategoriji
				for (let i = 0; i < kategorija.length; i++) {
					const element = kategorija[i]

					// Proverite da li je Naziv jednak nazivAktivnosti
					if (element.Naziv === nazivAktivnosti) {
						// Ako je Naziv jednak, vratite vrednost Trajanje iz tog elementa
						return element.Trajanje
					}
				}
			}
		}

		// Ako aktivnost nije pronađena, možete vratiti neku podrazumevanu vrednost ili null
		return null
	}

	const calculateTrajanjeAndIznos = (oldPodaci) => {
		// Iterirajte kroz sve elemente u objektu 'podaci'
		const newPodaci = { ...oldPodaci }
		for (let kategorija in newPodaci) {
			let elementi = newPodaci[kategorija]
			for (let i = 0; i < elementi.length; i++) {
				let element = elementi[i]

				switch (element.Naziv) {
					case "Kupovina parcele":
						element.Trajanje = ""
						element.Iznos = element.C
						break
					case "Upravljanje projektom":
						element.Trajanje = ""
						element.Iznos = element.C
						break
					case "Projektovanje":
						element.MP = step2Items ? step2Items.brutoUkupno : undefined
						element.Trajanje = ""
						element.Iznos = element.c * element.MP
						break
					case "Gradsko građevinsko zemljište, takse":
						element.Trajanje = ""
						element.Iznos = element.C
						break
					case "Ostali radovi - rezerva":
						element.Trajanje = ""
						element.Iznos = element.C
						break
					case "Šipovi":
						element.MP =
							+(step1CalculatedData ? step1CalculatedData[11][1] : 0) +
							+(step1Items && step1Items[4] ? +step1Items[4].Vrednost : 0)
						element.Trajanje = Math.ceil(element.MP / 3)
						element.Iznos = element.c * element.MP
						break
					case "Zaštita temeljne jame sa iskopom i HI":
						element.MP =
							2 *
							(+(step1CalculatedData ? step1CalculatedData[11][1] : 0) +
								+(step1Items && step1Items[4] ? +step1Items[4].Vrednost : 0)) *
							3 *
							podzemnoSpratnost
						element.Trajanje = Math.ceil(element.MP / 16)
						element.Iznos = element.c * element.MP
						break
					case "AB radovi - podzemno":
						element.MP = step2Items
							? step2Items.spratType * step2Items.zauzetostPodzemno
							: undefined
						element.Trajanje = Math.ceil(
							10 + element.MP / podzemnoSpratnost / 30
						)
						element.Iznos = element.c * element.MP
						break
					case "AB radovi - nadzemno":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element.Trajanje = Math.ceil(
							7 + element.MP / nadzemnoSpratnost / 30
						)
						element.Iznos = element.c * element.MP
						break
					case "Zidarski radovi - spoljni zidovi":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = +element.MP * +element.ki
						element.Trajanje = Math.ceil(
							pronadjiTrajanjeZaAktivnost(newPodaci, "AB radovi - nadzemno") *
								0.7
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Zidarski radovi - unutrašnji zidovi":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = +element.MP * +element.ki
						element.Trajanje = Math.ceil(
							pronadjiTrajanjeZaAktivnost(newPodaci, "AB radovi - nadzemno") *
								0.3 -
								1
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Zidarski radovi - malterisanje":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = +element.MP * +element.ki
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Zidarski radovi - košuljica":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = +element.MP * +element.ki
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Krov sa termikom i olucima":
						element.MP = (step1CalculatedData
							? +step1CalculatedData[7][1]
							: 0
						).toFixed(0)
						element["MP*ki"] = +element.MP * +element.ki
						element.Trajanje = 30
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Ostali radovi - rezerva":
						element.Iznos = element.C
						break
					case "Završni radovi - podzemno":
						element.MP = step2Items
							? step2Items.spratType * step2Items.zauzetostPodzemno
							: undefined
						element.Trajanje = 30
						element.Iznos = element.c * element.MP
						break
					case "VIK - instalacije":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.MP
						break
					case "Elektro - instalacije":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.MP
						break
					case "Mašinske - instalacije":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.MP
						break
					case "Mašinske - liftovi":
						element.MP = 1
						element.Trajanje = 30
						element.Iznos =
							element.c * element.MP +
							(step2Items ? step2Items.cenaLiftaKlackalice : 0)
						break
					case "Keramičarski radovi sa HI":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Molersko farbarski radovi":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Stolarski radovi - vrata":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Parketarski radovi":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Bravarski radovi - stolarija":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Bravarski radovi - ograde":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = 30
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Suva gradnja":
						element.MP = step2Items
							? +step2Items.brutoNadzemnoUkupno
							: undefined
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = pronadjiTrajanjeZaAktivnost(
							newPodaci,
							"AB radovi - nadzemno"
						)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Fasaderski radovi":
						element.MP =
							step1Items && step1CalculatedData
								? 2 *
								  (+step1Items[4].Vrednost +
										+step1CalculatedData[0][1] / +step1Items[4].Vrednost) *
								  3 *
								  +step1CalculatedData[10][1]
								: 0
						element["MP*ki"] = (+element.MP * +element.ki).toFixed(0)
						element.Trajanje = Math.ceil(element.MP / 25)
						element.Iznos = element.c * element.ki * element.MP
						break
					case "Spoljno uređenje":
						element.MP =
							step1Items && step1CalculatedData
								? +step1Items[0].Vrednost - +step1CalculatedData[0][1]
								: 0
						element.Trajanje = Math.ceil(element.MP / 6)
						element.Iznos = element.c * element.MP
						break
					case "Ostali radovi - rezerva":
						element.Iznos = element.C
						break
					default:
						element.Trajanje = null
						element.Iznos = 0
						break
				}
			}
		}

		return newPodaci
	}

	const newPodaci = calculateTrajanjeAndIznos(rows)

	useEffect(() => {
		values.ukupniTroskovi = Object.values(newPodaci)
			.flat()
			.reduce((total, item: any) => total + item.Iznos, 0) as number

		osveziMaster(values)
	}, [values])

	const handleInputChange = async (
		group: any,
		itemIndex: number,
		columnKey: string,
		newValue: string | number
	) => {
		const updatedGroup = rows[group].map((item, index) =>
			index === itemIndex ? { ...item, [columnKey]: +newValue } : item
		)
		const updatedPodaci = { ...rows }
		updatedPodaci[group] = updatedGroup
		const newData = calculateTrajanjeAndIznos(updatedPodaci)

		setRows(newData)

		values.ukupniTroskovi = Object.values(newData)
			.flat()
			.reduce((total, item: any) => total + item.Iznos, 0) as number

		// await CFCUseCase.update(canvasId, values)
		osveziMaster(values)
	}

	return (
		<>
			<Box className={styles.box}>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onPrev}
				>
					Podzemno
				</Button>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onNext}
				>
					Dinamika
				</Button>
			</Box>
			<form onSubmit={handleSubmit} data-reactour="create-a-canvas">
				<PanelsTitle customTitle={"Troškovi"} useCustomTitle={true} />
				<Spacer />
				<Spacer />
				<Box className={styles.box}>
					<Grid
						container
						spacing={1}
						// alignItems="center"
						justify="center"
						// alignContent="center"
					>
						<Grid xs={12}>
							<table>
								<thead>
									<tr>
										<th style={{ textAlign: "left" }}>Naziv</th>
										<th style={{ textAlign: "left" }}> </th>
										<th style={{ textAlign: "left" }}>MP</th>
										<th style={{ textAlign: "left" }}>ki</th>
										<th style={{ textAlign: "left" }}>MP*ki</th>
										<th style={{ textAlign: "left" }}>c</th>
										<th style={{ textAlign: "left" }}>C</th>
										<th style={{ textAlign: "right" }}>Trošak</th>
										{/* <th style={{ textAlign: "center" }}>Trajanje</th> */}
									</tr>
								</thead>
								<tbody>
									{Object.keys(rows).map((group, groupIndex) => (
										<React.Fragment key={groupIndex}>
											<tr>
												<th colSpan={1}>{group}</th>
											</tr>
											{rows[group].map((item, itemIndex) => (
												<tr key={itemIndex}>
													<td style={{ width: "350px" }}>{item.Naziv}</td>
													<td style={{ width: "110px" }}>{item.NDT}</td>
													<td style={{ width: "110px" }}>
														{formatNumberZero(item.MP)}
													</td>
													<td style={{ width: "110px" }}>
														{formatNumber(item.ki)}
													</td>
													<td style={{ width: "110px" }}>
														{formatNumberZero(item["MP*ki"])}
													</td>

													<td>
														<input
															style={{ width: "70px" }}
															type="text"
															defaultValue={formatNumberZero(item.c)}
															onChange={(e) =>
																handleInputChange(
																	group,
																	itemIndex,
																	"c",
																	e.target.value
																)
															}
														/>
													</td>
													<td>
														<input
															style={{ width: "70px" }}
															type="text"
															defaultValue={formatNumberZero(item.C)}
															onChange={(e) =>
																handleInputChange(
																	group,
																	itemIndex,
																	"C",
																	e.target.value
																)
															}
														/>
													</td>
													<td style={{ width: "140px", textAlign: "right" }}>
														{formatNumber(item.Iznos)}
													</td>
													{/* <td style={{ width: "110px", textAlign: "center" }}>
														{item.Trajanje}
													</td> */}
												</tr>
											))}
											<tr>
												<td colSpan={7} style={{ textAlign: "right" }}>
													Suma:
												</td>
												<td style={{ width: "110px", textAlign: "right" }}>
													<strong>
														{formatNumber(
															rows[group].reduce(
																(total, item) => total + item.Iznos,
																0
															)
														)}
													</strong>
												</td>
											</tr>
										</React.Fragment>
									))}
									<tr>
										<td colSpan={7} style={{ textAlign: "right" }}>
											Ukupno:
										</td>
										<td style={{ width: "110px", textAlign: "right" }}>
											<strong>
												{formatNumber(
													Object.values(rows)
														.flat()
														.reduce((total, item: any) => total + item.Iznos, 0)
												)}
											</strong>
										</td>
									</tr>
								</tbody>
							</table>
						</Grid>
					</Grid>
				</Box>
			</form>
		</>
	)
}
